//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
    Button,
    FormControl,
    FormControlLabel,
    InputLabel, MenuItem,
    Modal,
    Select,
    TextField
} from '@mui/material';
//  -- Components ---------------------
import { Card, Col, message as MessageAlert, Row } from 'antd';
import Loading from 'components/Loading';
import React, { useCallback, useMemo, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Switch } from "antd";
import { cloneDeep, find, get, map , isEmpty } from "lodash";
import moment from "moment";
import { handleCreateOrganization , handleGetOrganization, handleUpdateOrganization } from 'store/organizations/thunks';
import styled from 'styled-components';
//  -- Constants ----------------------
import OrderBookGroup from 'containers/addBook/orderBookGroup';
import timeZone from "moment-timezone";
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useAllBook, useBookOrder } from 'store/books/selectors';
import { updateCanvasKeyInfo } from 'store/canvas/thunks';
import { handleCreateLicences } from 'store/licences/thunks';
import COLOR from 'utils/constants/color';
import { groupBookByOrder } from 'utils/lib/ebookHelper';
import CanvasConfig from './CanvasConfig';
import { initialPermissions } from 'utils/config/reference';
import dayjs from 'dayjs';
const TabWidth = '160px'
const TabHeight = '25px'
const INFO = [
    {
        key: "1nformate",
        label: "1nformate"
    },
    {
        key: "comunidad",
        label: "Comunidad"
    },
    {
        key: "balcónCultural",
        label: "Balcón cultural"
    },
    {
        key: "1WAYRESOURCES",
        label: "1WAYRESOURCES"
    },

]
const EXAMS = [
    {
        key: "exams",
        label: "Exams"
    },
    {
        key: "1WAYTEACHER",
        label: "1WAYTEACHER"
    },
    {
        key: "conectandome",
        label: "Conectandome"
    },


]
const APEXAMS = [
    {
        key: "ap",
        label: "AP Exam"
    },
    {
        key: "1WAYSTORY",
        label: "1WAYSTORY"
    }


]

const EBOOK_OPTION = [
    {
        key: "lessonPlan",
        label: "Lesson Plan"
    },
    {
        key: "teacherEdition",
        label: "Teacher Editions"
    }
]
const PRINT_OPTIONS =  [
    {
        key: "1nformate",
        label: "1nformate (printable)"
    },
    {
        key: "comunidad",
        label: "Comunidad (printable)"
    },
    {
        key: "balcónCultural",
        label: "Balcón cultural (printable)"
    },
    {
        key: "conectandome",
        label: "Conectandome (printable)"
    },
    {
        key: "ap",
        label: "AP (printable)"
    },
    {
        key: "story",
        label: "1WAY Story (printable)"
    },{
        key:"exams",
        label:"Exams (printable)"
    }
]




//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Header = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Wrapper = styled.form`
	margin: 0px auto;
    // max-width: 480px;
    width: 100%;
`;
const DemoButton = styled.div`
    border: 0.5px solid white;
    background-color: ${p => p.bgColor ? p.bgColor : `rgb(113,0,225)`};
    font-size: 10px;
    font-weight: 600;
    outline: none;
    width:${p => p.width ? p.width : `80px`};
    color: white;
    border-radius: 3px;
    text-align:center;
    height:${p => p.height ? p.height : `20px`};
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    display: flex;
`;
const SwitchWrapper = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;
const SwitchWrappers = styled.div`
    justify-content: flex-start;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-direction:row;
    width:100%;
    gap:24px;
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;

const SectionTitle = styled.div`
    font-size: 14px;
    color: #ffffff;
    background: ${p => p.bgColor ? p.bgColor : '#00c4cc'};
    padding: 4px 8px;
    border-radius: 6px !important;
    cursor: pointer;


    position: absolute;
    top: -10px;
    left: -6px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const ContainerSwitch = styled.div`
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
`;
const Labels = styled.div`
    color:black;
    font-weight:500;
    font-size:14px;
`;

const BookSection = styled.div`
    border: 2px solid #e9e9e9;
    box-shadow: ${(p) => p.active ? p.preActive ? "-3px 2px 8px 0px #9d0001, 3px 1px 5px #9d0000;" : " -3px 2px 8px 0px #00989d, 3px 1px 5px #00989d;" : ""};
    margin-bottom: 26px;
    position: relative;
    padding-left: 16px;
    padding-right: 16px;
    width: fit-content;
    margin-right: 16px;
    padding-bottom: 16px;
    width: 100%
`;

const BookSectionInr = styled.div`
    width: calc(100% - 2%);
    overflow-x: auto;
    padding-bottom: 10px;
`;

const ToglSectionInr = styled.div`
    width: calc(100% - 2%);
    overflow-x: auto;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
`;



const SwitchController = ({ bgColor, value, onChange = () => { }, label, width = '80px', height = '20px', disabled }) => {
    return (<SwitchWrapper>
        <DemoButton style={{ minHeight: 32 }} width={width} height={height} bgColor={bgColor}>{label}</DemoButton>
        <FormControlLabel
            style={{ marginTop: 8 }}
            control={
                <Switch
                    onChange={onChange}
                    name="view"
                    color="primary"
                    size="default"
                    checked={value}
                    className={"districForm"}
                    disabled={disabled ? disabled : false}
                />
            }
            className={"districForm"}
            label=""
        />
    </SwitchWrapper>)
}

const SwitchControllers = ({ bgColor, value, onChange = () => { }, label, width = '80px', height = '20px', disabled }) => {
    return (<SwitchWrappers>
        <DemoButton style={{ minHeight: 32 }} width={width} height={height} bgColor={bgColor}>{label}</DemoButton>
        <FormControlLabel
            style={{ marginTop: 8 }}
            control={
                <Switch
                    onChange={onChange}
                    name="view"
                    color="primary"
                    size="default"
                    checked={value}
                    className={"districForm"}
                    disabled={disabled ? disabled : false}
                />
            }
            className={"districForm"}
            label=""
        />
    </SwitchWrappers>)
}

const defaultCanvasSec = {
    id: null, base_url: '', key: '', secrate: '', created_on: '', api_version: 'api/v1', orgId: "", display_name:'', redirect_uri: 'https://nosotrosonline.com/login'
}

const DistrictForm = ({
    district,
    editing,
    onClose,
    org_permission
}) => {
    const dispatch = useDispatch();
    const [data, setData] = useState({ demo: true, startDate: moment().format("YYYY-MM-DD") });
    const [permissions, setPermissions] = useState(initialPermissions)
    const [loading, setLoading] = useState(false);
    const [licensesError, setLicensesError] = useState(false);
    const [licensesErrorMsg, setLicensesErrorMsg] = useState('');
    const [alertForAccount, setAlertForAccount] = useState(false)
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [isCanvas, setIsCanvas] = useState(false)
    const [dataLoading, setDataLoading] = useState(false)
    const [canvasKeyInfo, setCanvasKeyInfo] = useState(defaultCanvasSec);
    const booksAllList = useAllBook()
    const bookOrder = useBookOrder()
  	 const navigate = useNavigate();
    const can_be_canvas = ! Boolean(district?.classlinkid || district?.cleverId || district?.schoolId) 
    useEffect(() => {
        setData(p=>({...p,licenses:district?.allocated_license || 0}))
        if (!isEmpty(district)) {
            if(district.canvas_id) {
                setIsCanvas(true)
            }else{
                setIsCanvas(false)
            }
            setData(district)
        } else {
            setData({ demo: true, startDate: moment().format("YYYY-MM-DD") })
            setIsCanvas(false)
        }
    }, [district])

    useEffect(() => {
        if(org_permission&&Object.keys(org_permission).length>0){
            setPermissions(org_permission)
        }
    }, [org_permission])
    const handleChange = e => {
        // if (Number(e.target.value) < Number(data.maxCount)) {

        //     setLicensesError(true);
        //     setLicensesErrorMsg('Assigned licenses cannot be less than already used.');
        // }
        // else {
        //     setLicensesError(false);
        //     setLicensesErrorMsg('');
        // }

        setData({
            ...data,
            [e.target.id]: e.target.value
        });


    };

    const onSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setDataLoading(true)
        if (data.displayName == '' || !data.displayName) return;
        setLoading(true);
        if(isCanvas&&!canvasKeyInfo.id){
            setDataLoading(false)
            setLoading(false);
             MessageAlert.error(`Canvas key information are required for this district please add.`)
            return
        }
        if (editing) {
            await dispatch(handleUpdateOrganization(district.id, {
                ...district,
                ...data,
                permissions,
                canvas_id: canvasKeyInfo.id ? canvasKeyInfo.id : null
            }));
            if(canvasKeyInfo.id){
                await updateCanvasKeyInfo({...canvasKeyInfo,orgId:district.id});
            }
            await dispatch(handleGetOrganization(district.id));
            onClose();
            navigate('/data-browsers');
        } else {
            const createDistrict = await dispatch(handleCreateOrganization({
                ...data,
                canvas_id: canvasKeyInfo.id ? canvasKeyInfo.id : null,
                typeId: 'district',
                logo: '',
                parentId: 'null',
                studentCount: 0,
                maxCount: 0,
                permissions
            }));;
            if (createDistrict) {
              await  dispatch(handleGetOrganization(createDistrict?.id))
            }
            const now = moment();
            const unixTimestamp = now.valueOf();
            if(canvasKeyInfo.id){
                await updateCanvasKeyInfo({...canvasKeyInfo,orgId:createDistrict.id});
            }
            dispatch(handleCreateLicences({
                districtId: get(createDistrict, 'id', ''),
                allocatedLicense: get(createDistrict, 'licenses', ''),
                usedLicense: get(createDistrict, 'maxCount', 0),
                // schoolId: null,
                modified: unixTimestamp,
                availableLicenses: get(createDistrict, 'licenses', '')
            }))
            onClose();
            navigate('/data-browsers');
        }
        setDataLoading(false)
        setLoading(false);
    };
    const handlePermissionChange = (key, value) => {
        const resp = permissions;
        resp[key] = value;
        setPermissions(resp)
        forceUpdate()
    }
    const onPrintOptionChange = (key, value) => {
        const print_permission = permissions.print_permission;
        print_permission[key] = value;
        const new_permissions = { ...permissions };
        new_permissions.print_permission = print_permission;
        setPermissions(new_permissions)
        forceUpdate()
    }
    const handleUpdateData = (key, value) => {
        const resp = data;
        resp[key] = value;
        setData(resp)
        forceUpdate()
    }
    const getValue = (key) => {
        return permissions[key]
    }
    const getPrintValue = (key) => {
        return permissions&&permissions.print_permission&&permissions.print_permission[key]
    }

    const getData = (key) => {
        return data[key]
    }
    const backToDataBrowser = () => {
        navigate('/data-browsers');
    };

 
    const onBookLicenseChange = (checked, title , order_key) => {
        const resp = permissions;
        let countable = resp[`licenses-count`] || []
        const is_exist_index = countable.findIndex(k => k.title == title || k.key == order_key)
        if (countable.length == 0) {
            countable = [{
                key: order_key,
                title: title,
                count: checked
            }]
        } else {
            if (is_exist_index >= 0) {
                countable[is_exist_index].count = checked
            } else {
                countable.push({
                    key: order_key,
                    title: title,
                    count: checked
                })
            }
        }
        resp[`licenses-count`] = countable;
        setPermissions(resp)
        forceUpdate()
    };
    const getBookLicensesCountStatus = (title , order_key) => {
        let countable = permissions[`licenses-count`] || []
        let keytitle = title.replace(/\s+/g, '')
        const is_exist = countable.find(k => k.key == keytitle || k.title == title || k.key == order_key)
        if (is_exist) {
            return is_exist.count
        }
        return true;
    }
    const orderedBook = useMemo(()=>groupBookByOrder(booksAllList, bookOrder),[booksAllList,bookOrder]);
 

    const getEnableStatusBookGroup = useCallback((key) => {
        const bookPermissions = get(permissions, "books_group_permission", []) || []
        const item = find(bookPermissions, k => k == key);
        const isEnabled = Boolean(item);
        const message = "Books are disabled prior, please enable or disable by grouping!"
        return ({ isEnabled, message })
    }, [permissions])

    const handleEnableDisableByGroup = useCallback((key) => {
        setPermissions(prevPermissions => {
            const current = prevPermissions.books_group_permission || [];
            const updated = current.includes(key)
                ? current.filter(k => k !== key)
                : [...current, key];

            return {
                ...prevPermissions,
                books_group_permission: updated,
            };
        });
    }, []);
    // const enableDiableGroup = (status,groups) => {
    //      handleBookAvailableChanges(map(groups,k=>k.id),status)
    // }
    const handleConfigPermissionUpdate = (key,value) => {
        try{
            const permissionsData = {...permissions};
            if(!permissionsData.config){
                permissionsData.config = {};
            }
            permissionsData.config[key] = value;
            setPermissions(permissionsData);
        }catch(error){
            console.log(error,123);
        }
    }
    return (
        <Wrapper onSubmit={onSubmit}>
            <Modal
                open={alertForAccount}
                onClose={() => setAlertForAccount(false)}
            >
                <ModalContent>
                    Are you sure you want to {get(permissions, "userActive", true) ? "enable" : "disable"} this district
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                handlePermissionChange("userActive", !permissions.userActive)
                                setAlertForAccount(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginRight: '4px' }}
                            color="secondary"
                            variant="contained"
                            className={`${dataLoading ? "disabled-button" : ""}`}
                            onClick={() => onSubmit()}
                        >
                            {dataLoading ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <div className="FilterHeading">
                <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title={editing ? 'Update District' : 'Create District'}

                >
                    <Row className='fixAdminInputDistict' gutter={[24, 24]} style={{ width: '100%', marginTop: 8 }}>

                        <Col span={24}>
                            {/* <Header >{editing ? 'Update District' : 'Create District'}</Header> */}
                            <Row className="floatingLabelBG">
                                <TextField
                                    id="displayName"
                                    onChange={handleChange}
                                    label="District Name"
                                    variant="outlined"
                                    value={data?.displayName}
                                    style={{ borderColor: COLOR.black100, background: 'white' }}
                                />
                            </Row>
                            <Row style={{ marginTop: 25 }} className="floatingLabelBG">
                                <TextField
                                    id="licenses"
                                    error={licensesError}
                                    onChange={handleChange}
                                    label="Licenses"
                                    variant="outlined"
                                    helperText={licensesError && licensesErrorMsg}
                                    value={data?.licenses}
                                    style={{ borderColor: COLOR.black100 }}
                                />
                            </Row>
                            {editing && <Row style={{ marginTop: 25 }} className="floatingLabelBG">
                                <TextField
                                    disabled
                                    id="usedLicenses"
                                    label="Used Licenses"
                                    variant="outlined"
                                    value={data?.total_utilized}
                                    style={{ borderColor: COLOR.black100 }}
                                />
                            </Row>}
                            {editing && <Row style={{ marginTop: 25 }} className="floatingLabelBG">
                                <TextField
                                    disabled
                                    id="freeLicenses"
                                    label="Licenses Available"
                                    variant="outlined"
                                    value={Math.max(data?.licenses - data?.total_utilized,0)}
                                    style={{ borderColor: COLOR.black100 }}
                                />
                            </Row>}
                            <Row style={{ marginTop: 25 }} className="floatingLabelBG">
                                <FormControl variant="outlined">
                                    <InputLabel id="timezonelabel" style={{ borderColor: COLOR.black100 }}>Select Timezone</InputLabel>
                                    <Select
                                        labelId="timezonelabel"
                                        id="timezone"
                                        onChange={e => {
                                            setData({
                                                ...data,
                                                timezone: e.target.value
                                            });
                                        }}
                                        value={get(data, "timezone", timeZone.tz.guess())}
                                        style={{ borderColor: COLOR.black100 }}
                                    >
                                        {map(timeZone.tz.names(), tz => (
                                            <MenuItem key={tz} value={tz}>
                                                {tz}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Row>
                            <CanvasConfig
                                isCanvas={isCanvas}
                                setIsCanvas={setIsCanvas}
                                setCanvasKeyInfo={setCanvasKeyInfo}
                                can_be_canvas={can_be_canvas}
                                disabled={get(data, "canvas_id", null) ? true : editing}
                                canvasKeyInfo={canvasKeyInfo}
                                canvas_id={data?.canvas_id} 
                                orgId={data?.id}
                            />
                              <div className='startEndDateCstm'>
                                    <DatePicker
                                        label="Start Date"
                                        format="MM-DD-YYYY"
                                        value={getData('startDate') ? dayjs(getData('startDate')) : null}
                                        minDate={dayjs()}
                                        onChange={(newValue) => {
                                            handleUpdateData('startDate', newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
                                            if (data.endDate && dayjs(data.endDate).isBefore(newValue)) {
                                                handleUpdateData('endDate', null);
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                variant: 'outlined',
                                                placeholder: 'Start date',
                                                className: 'districFormDate',
                                                InputLabelProps: {
                                                    shrink: true,
                                                },
                                                style: { width: '45%' }
                                            }
                                        }}
                                    />
                                    
                                    <DatePicker
                                        label="End Date"
                                        format="MM-DD-YYYY"
                                        value={getData('endDate') ? dayjs(getData('endDate')) : null}
                                        minDate={
                                            data.startDate 
                                                ? dayjs(data.startDate) 
                                                : dayjs()
                                        }
                                        onChange={(newValue) => {
                                            handleUpdateData('endDate', newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
                                        }}
                                        slotProps={{
                                            textField: {
                                                variant: 'outlined',
                                                placeholder: 'End date',
                                                className: 'districFormDate',
                                                InputLabelProps: {
                                                    shrink: true,
                                                },
                                                style: { width: '45%' }
                                            }
                                        }}
                                    />
                              </div>     
                            {editing && <Row gutter={[16, 24]} style={{ marginTop: 20, paddingLeft: 10, justifyContent: "space-between", paddingRight: 10 }} >
                                <SwitchControllers bgColor={'rgb(203,17,118)'} label={`${"ACTIVE/DEACTIVE"} - ALL DISTRICT ACCOUNT`} width={100} height={'30px'} value={get(permissions, "userActive", true)} onChange={e => {
                                    setAlertForAccount(true)
                                    handlePermissionChange("userActive", e)
                                }
                                } />
                            </Row>}
                        </Col>

                    </Row>
                </Card>
            </div>
            <div className="FilterHeading">
                <Card
                    style={{ marginTop: 16, marginBottom: 20 }}
                    type="inner"
                    title={editing ? 'Update District' : 'Create District'}
                >
                    <Row gutter={[24, 24]} style={{ width: '100%', marginTop: 8 }}>
                        <Col span={24}>
                            <Row gutter={[16, 24]} style={{}}>
                                {map(INFO, item => (<div style={{ margin: '0px 10px' }} key={item.key}><SwitchController label={item.label} value={getValue(item.key)} onChange={handlePermissionChange.bind(this, item.key)} width={TabWidth} height={TabHeight} /></div>))}

                            </Row>
                            <Row gutter={[16, 24]} style={{ marginTop: 12 }}>
                                {map(EXAMS, item => (<div style={{ margin: '0px 10px' }} key={item.key}><SwitchController label={item.label} value={getValue(item.key)} width={TabWidth} height={TabHeight} onChange={handlePermissionChange.bind(this, item.key)} /></div>))}

                            </Row>
                            <Row gutter={[16, 24]} style={{ marginTop: 12 }}>
                                {map(APEXAMS, item => (<div style={{ margin: '0px 10px' }} key={item.key}><SwitchController label={item.label} value={getValue(item.key)} width={TabWidth} height={TabHeight} onChange={handlePermissionChange.bind(this, item.key)} /></div>))}

                            </Row>
                            <Row gutter={[16, 24]} style={{ marginTop: 12 }}>
                                {map(EBOOK_OPTION, item => (<div style={{ margin: '0px 10px' }} key={item.key}><SwitchController label={item.label} value={getValue(item.key)} onChange={handlePermissionChange.bind(this, item.key)} width={TabWidth} bgColor={COLOR.bluelight} height={TabHeight} /></div>))}
                            </Row>

                            <Row gutter={[16, 24]}>
                               <ToglSectionInr style={{ marginTop: 12 , border:"1px dotted" , paddingTop:12}}>
                                 {map(PRINT_OPTIONS, item => (<div style={{ margin: '0px 10px' }} key={item.key}><SwitchController label={item.label} value={getPrintValue(item.key)} onChange={onPrintOptionChange.bind(this, item.key)} width={TabWidth} bgColor={COLOR.blue} height={TabHeight} /></div>))}
                               </ToglSectionInr>
                            </Row>
                            <Col>
                                <Row gutter={[24, 24]} style={{ width: '100%', paddingLeft: 10, marginBottom: 20, marginTop: 12 }}>
                                    <div className='flex items-center gap-10px'>
                                        <SwitchControllers label={"DEMO"} bgColor={COLOR.orange100} value={getData('demo')} onChange={handleUpdateData.bind(this, 'demo')} />
                                        <SwitchControllers label={"Audio Download"} width='120px' bgColor={COLOR.orange100} value={permissions?.config?.audio_download} onChange={handleConfigPermissionUpdate.bind(this, 'audio_download')} />
                                        <SwitchControllers label={"Audio Transcript Download"} width='160px' bgColor={COLOR.orange100} value={permissions?.config?.audio_transcript_download} onChange={handleConfigPermissionUpdate.bind(this, 'audio_transcript_download')} />
                                        <SwitchControllers label="Download PPT" width='160px' bgColor={COLOR.orange100} value={permissions?.config?.download_ppt} onChange={handleConfigPermissionUpdate.bind(this, 'download_ppt')} />
                                    </div>
                                </Row>
                            </Col>


                            {/* book grouping code  */}
                            <Row style={{ marginTop: '1%' }}>
                                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                                    {/* <Section style={{ fontSize: '18px' }}
                                        description="Resources books"
                                        header='Resources'> */}
                                    {map(orderedBook, (books, index) => {
                                        // const {isEnabled , message }  = getEnableStatus(cloneDeep(books));
                                        const {isEnabled , message }  = getEnableStatusBookGroup(books.key);

                                        return (
                                            <LinkArea>
                                                <Row>
                                                    <Col span={24} style={{ marginBottom: 10  , display:"flex", flexDirection:"row" }}>
                                                        <ContainerSwitch style={{ marginBottom: 16, marginTop: 16, marginLeft: 16 }}>
                                                            <Labels>Enable</Labels>
                                                            <Switch checked={isEnabled} onChange={(e) => handleEnableDisableByGroup(books.key)} />
                                                        </ContainerSwitch>
                                                        <ContainerSwitch style={{ marginBottom: 16, marginTop: 16, marginLeft: 16 }}>
                                                            <Labels>Activate paid licenses.</Labels>
                                                            <Switch disabled={!isEnabled} checked={!isEnabled ? isEnabled : getBookLicensesCountStatus(books.title, books.key)} onChange={e => onBookLicenseChange(e, books.title, books.key)} />
                                                        </ContainerSwitch>
                                                    </Col>
                                                </Row>
                                                <Col span={24} style={{ marginBottom: !isEnabled?10:0 }}>
                                                     {!isEnabled &&<span>{message}</span> }
                                                </Col>
                                                <Row style={{ marginTop: '1%', marginLeft: 20 }}>
                                                    <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                                                        <BookSection>
                                                          <BookSectionInr>
                                                            <SectionTitle bgColor={books.color} >{books.title}</SectionTitle>
                                                            <OrderBookGroup chapter={cloneDeep(books?.books)} disabled={true}  onRearrangeDone={()=>{}} 
                                                            hasPrintToogle={true} onPrintOptionChange={onPrintOptionChange} print_permissions={permissions.print_permission} />
                                                          </BookSectionInr>
                                                        </BookSection>
                                                    </Col>
                                                </Row>
                                            </LinkArea>
                                        )
                                    })}
                                    {/* </Section> */}
                                </Col>
                            </Row>                
                        </Col>
                    </Row>
                </Card>
            </div>
            <Row style={{ width: '100%', marginTop: 8 }}>
                <Col span={4}>
                    <Button disabled={!data.displayName || licensesErrorMsg} style={{ width: '100%' }} variant="contained" color="primary" type='submit'>
                        {loading ? <Loading size={20} white /> : (editing ? 'Update' : 'Create')}
                    </Button>
                </Col>
                <Col span={16}></Col>
                <Col span={4}>
                    <Button variant="contained" color="secondary" className={"districForm"} onClick={backToDataBrowser} style={{ marginRight: '8px', width: '100%', textTransform: 'inherit' }}>
                        Cancel
                    </Button>
                </Col>
            </Row>
        </Wrapper>
    );
};

export default DistrictForm;
